

export class Geojson{
    constructor(){
        var _type, _features;
        var _typeSet = new Set(['Feature','FeatureCollection','Point', 'MultiPoint', 'LineString',
        'MultiLineString', 'Polygon', 'MultiPolygon', 'GeometryCollection'])

        Object.defineProperty(this,'type',{
            set : function(t){ 
                if (_typeSet.has(t)){
                    _type = t;
                }
            },
            get : function(){ return _type },
            enumerable : true 
        });  

        Object.defineProperty(this,'features',{
            set : function(f){ _features = f },
            get : function(){ return _features },
            enumerable : true
        });

    }
	
	getFeatures(){  return this.features; }
	getType(){ return this.type }
	
	setFeaturesFilter(filter){ this.features = this.features.filter(filter) }
}

export class Feature{
    constructor(){
        var _type, _geometry, _properties; 
        var _typeSet = new Set(['Feature','FeatureCollection','Point', 'MultiPoint', 'LineString',
        'MultiLineString', 'Polygon', 'MultiPolygon', 'GeometryCollection'])

        Object.defineProperty(this,'type',{
            set : function(t){ 
                if (_typeSet.has(t)){
                    _type = t;
                }
            },
            get : function(){ return _type },
            enumerable : true 
        });  
        
        Object.defineProperty(this,'geometry',{
            set : function(g){ _geometry = g },
            get : function(){ return _geometry },
            enumerable : true 
        });

        Object.defineProperty(this,'properties',{
            set : function(p){ _properties = p },
            get : function(){ return _properties },
            enumerable : true 
        });
    }
	getType(){ return this.type }
	getGeometry(){ return this.geometry }
	getProperties(){ return this.properties }
}

export class Geometry{
    constructor(){
        var _type, _coordinates;
        var _typeSet = new Set(['Feature','FeatureCollection','Point', 'MultiPoint', 'LineString',
        'MultiLineString', 'Polygon', 'MultiPolygon', 'GeometryCollection'])

        Object.defineProperty(this,'type',{
            set : function(t){ 
                if (_typeSet.has(t)){
                    _type = t;
                }
            },
            get : function(){ return _type },
            enumerable : true 
        }); 
 
        Object.defineProperty(this,'coordinates',{
            set : function(g){ _coordinates = g },
            get : function(){ return _coordinates },
            enumerable : true 
        });
        
    }
    getCoordinates(){ return this.coordinates }
	
	getLatitude(){ return this.coordinates[1] }
	
	getLongitude(){ return this.coordinates[0] }
}

export class Properties{
    constructor(){
		var  _poiName, _city, _category, _commune;
		
		
		Object.defineProperty(this,'poiName',{
			set : function(v){
				_poiName = v;
			},
			get : function(){
				return _poiName;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'city',{
			set : function(v){
				_city = v;
			},
			get : function(){
				return _city;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'commune',{
			set : function(v){
				_commune = v;
			},
			get : function(){
				return _commune;
			},
			enumerable : true
		});
		
		Object.defineProperty(this,'category',{
			set : function(v){
				_category = v;
			},
			get : function(){
				return _category;
			},
			enumerable : true
		});
		
		this.label;


    }
	getName(){ return this.poiName }
	getCity(){ 
		return (this.commune || this.city);
	}
	getLabel(){ return this.label }
}
